import React from 'react';
import classNames from 'classnames';
import styles from '../assets/providers-grid.module.scss';
import { Paginated } from 'src/services/api-handlers/pagination';
import Grid, { Column } from './react-table/Grid';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import textFilter from 'src/components/react-table/filters/text-filter';
import { QueryParams } from 'src/types/grid';
import { IProvider } from 'src/types/provider';
import ProviderActionsColumn from './ProviderActionsColumn';
import ProviderDetailColumn from './ProviderDetailColumn';
import { CellProps } from 'react-table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { changeToZeroMoment } from '../../../../../../../helpers/timeHelpers';
import dropdownFilter from '../../../../../../../components/react-table/filters/dropdown-filter';
import GeneralEnum from '../../../../../../../enumerables/general-enum';
import { getValFromEnum } from '../../../../../../../components/redux-form/utils/dropdown-values';
import Router from '../../../../../../../navigation/router';
import { routes } from '../../../../../../../navigation';
import { useCookies } from 'react-cookie';

interface Props {
    data: Paginated<Partial<IProvider>>;
    getData: (params: QueryParams) => void;
    getDataCsv: (params: QueryParams) => void;
    inProgressCSV: boolean;
}

const ProviderFilterStatus = GeneralEnum ? GeneralEnum.getEnum('UserStatus') : {};

const statusFilterValues: SelectObject[] = getValFromEnum(ProviderFilterStatus);

statusFilterValues.pop();

const columns: Column<Partial<IProvider>>[] = [
    {
        Header: 'Name',
        accessor: 'fullName',
        Cell: ProviderDetailColumn,
        Filter: textFilter<IProvider>(),
    },
    {
        Header: 'Total of sessions',
        accessor: 'sessionScheduledByNow',
        Filter: textFilter<IProvider>(),
    },
    {
        Header: 'Total of sessions confirmed on time',
        accessor: 'sessionConfirmedInTimeSessionByNow',
        Filter: textFilter<IProvider>(),
    },
    {
        Header: '% of confirmed on time',
        accessor: 'sessionConfirmPercentage',
        disableFilters: true,
        disableSortBy: true,
        Filter: textFilter<IProvider>(),
    },

    {
        Header: 'Actions',
        accessor: 'id',
        Cell: ProviderActionsColumn,
        disableSortBy: true,
        disableFilters: true,
    },
];

const ProvidersGrid: React.FunctionComponent<Props> = ({ data, getData, getDataCsv, inProgressCSV }: Props) => {
    const filtersInit: any[] = [];
    filtersInit.push({ id: 'status', value: 1 });
    filtersInit.push({ id: 'analytics', value: 1 });

    /*const [cookiesDateFrom, setCookieDateFrom] = useCookies(['fromDate']);
    const [cookiesDateTo, setCookieDateTo] = useCookies(['toDate']);
    setCookieDateFrom('fromDate', undefined, {
        path: '/',
    });
    setCookieDateTo('toDate', undefined, {
        path: '/',
    });*/

    return (
        <div className={classNames(styles.grid)}>
            <Grid<Partial<IProvider>>
                filterGlobal={true}
                filtersInit={filtersInit}
                columns={columns}
                data={data}
                getData={getData}
                getDataCsv={getDataCsv}
                inProgressCSV={inProgressCSV}
            />
        </div>
    );
};

export default ProvidersGrid;
